import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "user-profile__content" }
const _hoisted_2 = {
  key: 2,
  class: "user-profile__icon-location"
}
const _hoisted_3 = { class: "user-profile__info" }
const _hoisted_4 = {
  key: 0,
  class: "user-profile__btn-notice__badge"
}
const _hoisted_5 = { class: "user-profile__holder-rating" }

import { IonImg, IonIcon, IonButton, IonText } from '@ionic/vue';
import StarRating from '@/modules/General/components/StarRating.vue';
import { useBreakpoint } from "@/hooks/useBreakpoint";
import VueAvatar from "@webzlodimir/vue-avatar";
import "@webzlodimir/vue-avatar/dist/style.css";
import { RouteNamesEnum } from '@/const/routes';
import router from '@/router';
import { computed, ref } from 'vue';
import { capitalizeEachWord } from '@/helpers/formaters';
import { EventNamesEnum } from '@/const/events';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileUser',
  props: {
    hideFeedbackButton: { type: Boolean },
    hideNoticeButton: { type: Boolean },
    avatarSrc: { default: '' },
    teamName: { default: '' },
    userName: { default: '' },
    titleId: { default: 'Member ID' },
    memberId: { default: '' },
    userId: { default: '' },
    userRating: { default: 0 },
    showFeedback: { type: Boolean, default: false },
    isPrimary: { type: Boolean, default: false },
    isTracking: { type: Boolean, default: false },
    feedbacksCount: {},
    showEditButton: { type: Boolean, default: false },
    isUser: { type: Boolean },
    hasUnreadEvents: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const hasUnreadEvents = computed(() => props?.hasUnreadEvents)

const emits = __emit;

const navigate = (item: any) => {
  emits(EventNamesEnum.OnNavigate, item);
}

const imgExists = ref<boolean>(true);

const navigateToUserEdit = () => {
  router.push({
    name: RouteNamesEnum.UsersEdit,
    params: { id : props.userId }
  });
}

const { isDesktop } = useBreakpoint();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["user-profile__image", {'user-profile__image--is-primary': _ctx.isPrimary}])
    }, [
      (_ctx.avatarSrc && imgExists.value)
        ? (_openBlock(), _createBlock(_unref(IonImg), {
            key: 0,
            class: "user-profile__avatar",
            src: `${_ctx.avatarSrc}?${new Date().getTime()}`,
            onIonImgDidLoad: _cache[0] || (_cache[0] = ($event: any) => (imgExists.value = true)),
            onIonError: _cache[1] || (_cache[1] = ($event: any) => (imgExists.value = false))
          }, null, 8, ["src"]))
        : (_openBlock(), _createBlock(_unref(VueAvatar), {
            key: 1,
            style: {"width":"100%","height":"100%"},
            username: _unref(capitalizeEachWord)(_ctx.userName)
          }, null, 8, ["username"])),
      (_ctx.isTracking)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(IonIcon), {
              color: _ctx.isPrimary ? 'success' : 'primary',
              src: "assets/icon/location.svg"
            }, null, 8, ["color"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.hideNoticeButton && !_unref(isDesktop))
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 0,
            class: "user-profile__btn-notice ion-no-padding",
            fill: "clear",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate({name: _unref(RouteNamesEnum).Notifications})))
          }, {
            default: _withCtx(() => [
              (hasUnreadEvents.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                src: "assets/icon/notice.svg"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonText), { class: "user-profile__team-name" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.teamName), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonText), { class: "user-profile__name" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.userName), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonText), { class: "user-profile__id" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.titleId) + ": " + _toDisplayString(_ctx.userId), 1)
        ]),
        _: 1
      }),
      (_ctx.memberId)
        ? (_openBlock(), _createBlock(_unref(IonText), {
            key: 1,
            class: "user-profile__id"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Member ID: " + _toDisplayString(_ctx.memberId), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(StarRating, {
          class: "user-profile__rating",
          "model-value": _ctx.userRating,
          readonly: ""
        }, null, 8, ["model-value"]),
        (_ctx.showFeedback)
          ? (_openBlock(), _createBlock(_unref(IonText), {
              key: 0,
              class: "user-profile__feedback"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" (from " + _toDisplayString(_ctx.feedbacksCount) + " review(s)) ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideFeedbackButton)
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 2,
            class: "user-profile__button",
            fill: "clear",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isUser ? navigate({name: _unref(RouteNamesEnum).UserFeedbacks, id: _ctx.userId}) : _unref(isDesktop) ? navigate({name: _unref(RouteNamesEnum).DirectoryTeam, id: _ctx.memberId, query: { tab: 3}}) : navigate({name: _unref(RouteNamesEnum).DirectoryDetails, id: _ctx.memberId, query: { activeTab: 3 }})))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" ("),
              _createElementVNode("span", null, "view feedback", -1),
              _createTextVNode(") ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showEditButton)
      ? (_openBlock(), _createBlock(_unref(IonButton), {
          key: 0,
          class: "user-profile__button-edit",
          onClick: navigateToUserEdit,
          fill: "clear"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { src: "assets/icon/edit.svg" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})